<template>
    <div
        class="flex h-full w-full flex-col overflow-hidden rounded-20 bg-white/20 backdrop-blur-sm">
        <h2
            :class="textCenter ? 'text-center' : ''"
            class="px-5 pt-5 text-lg font-bold leading-tight text-white">
            {{ groupName }}
        </h2>

        <div
            :class="
                textCenter
                    ? 'w-full justify-between max-md:flex-col'
                    : 'flex-col'
            "
            class="mt-4 flex gap-2 px-3 pb-3">
            <AtomDiagramCard
                v-for="product in products"
                :is-active="product.slug === currentProductSlug"
                :key="product.id"
                :product="product" />
        </div>
    </div>
</template>

<script setup lang="ts">
import AtomDiagramCard from '~/components/atom/atom-diagram-card/AtomDiagramCard.vue'
import type { IProductCard } from '~/components/particles/product-card/product-card.types'

interface Props {
    groupName: string
    textCenter?: boolean
    currentProductSlug: string
    products: IProductCard[]
}

defineProps<Props>()
</script>
